module.exports = __webpack_public_path__ + "static/media/8.1.3.2.yandex_alisa_prilozhenie.3c5a432b.png";